import { useEffect, useRef, useState } from "react";
import LayoutNode, { AttributeCollection, getNodeComponentAttributeValue, GetNodeRealId, setNodeComponentAttributeValue } from "../Definitions/LayoutNode";
import React from "react";
import { DownCaret } from "../Icons/Carets";
import { ClosestWithClass } from "../Utilities/HTMLHelpers";
import { ToggleNames } from "../Binding/BindAllToggles";
import { wBComponentTypeNames } from "../Definitions/WBComponentTypeNames";
import { createPortal } from "react-dom";

export default function RenderTabMobileMenu({node,isEditor,inSelection}:{inSelection?:number, node:AttributeCollection,isEditor?:boolean}) {

    let tabs = getNodeComponentAttributeValue(node,"tab-list","").split("\n");

    const domRef = useRef<HTMLDivElement>(null);
    const containerRef = useRef<HTMLElement|null>(null);
    const optionsRef = useRef<HTMLDivElement>(null);
    const [isOpen,setIsOpen] = useState(false);
    const [styleState,setStyleState] = useState("");
    const [selectedTab,setSelectedTab] = useState(inSelection??0);
    const portalRef = useRef<any>(null);
    const heightRef = useRef<number>(0);
    const OpenMenu = ()=>{
        if(containerRef.current){
            containerRef.current.classList.add("menu-opened");
        }
        if(domRef.current){
            heightRef.current = domRef.current.clientHeight;
        
        }

        setIsOpen(true);
    }
    const CloseMenu = (e:any)=>{

        if(domRef.current ){         
            let dom = domRef.current;
            let target = e.target as HTMLElement;
            if(!dom.contains(target)){
                if(containerRef.current){
                    containerRef.current.classList.remove("menu-opened");
                }
                setIsOpen(false);
            }
        }


    }

    useEffect(()=>{
        if(domRef.current){


            //when initialized, get all buttons and make sure the selected tab stays in sync.
            let parent = ClosestWithClass(domRef.current,"v-tabs");

            let portal = parent?.querySelector(".tab-dropdown-portal");
            if(portal){
                portalRef.current = portal as any;
            }
            if(parent && !isEditor){
                containerRef.current = parent as any;
                let tabButtons= parent.querySelectorAll(".tab-button");
                if(tabButtons)
                for(let i = 0;i<tabButtons.length;i++){
                    let num = tabButtons[i].getAttribute(ToggleNames.ToggleIndexAttribute);
                    let parse = parseInt(num??"");
                    if(!isNaN(parse)){
                        tabButtons[i].addEventListener("click",()=>{
                            setSelectedTab(parse);
                        })
                    }
                }
             }
        }

       
        document.addEventListener("click",CloseMenu);
        return ()=>{
            document.removeEventListener("click",CloseMenu);
        }
     
    },[])

    useEffect(()=>{

        if(!isEditor){
            let realId = getNodeComponentAttributeValue(node,"realid");

            let allowListDom = document.getElementById("allow-list");
            if(allowListDom){
                let allowObject = JSON.parse(allowListDom.innerText);
                let newStyle = "";
                let currentComponents = getNodeComponentAttributeValue(node,"component-lists").split("\n");
                let selected = 0;
                let hiddenCount = 0;
                for(let i = 0;i<currentComponents.length;i++){
             
                    let compList = currentComponents[i].split(",");
                    if(compList.length<1||(compList.length==1&&compList[0].length<1)){
                        continue; // no synced components so ignore
                    }

                    let valid = false;
                 
                    for(let e = 0;e<compList.length;e++){
                        switch(compList[e]){
                            case wBComponentTypeNames.businessBookNow:
                                if(allowObject.bookNow){
                                    valid = true;
                                }
                                break;
                             case wBComponentTypeNames.businessClass:
                            if(allowObject.class){
                                valid = true;
                            }
                            break;
                            case wBComponentTypeNames.businessServices:
                                if(allowObject.services){
                                    valid = true;
                                }
                                break;
                            case wBComponentTypeNames.businessProducts:
                                if(allowObject.products){
                                    valid = true;
                                }
                                break;
                            case wBComponentTypeNames.businessPackages:
                                if(allowObject.packages){
                                    valid = true;
                                }
                                break;
                            case wBComponentTypeNames.businessDailyDeals:
                                if(allowObject.deals){
                                    valid = true;
                                }
                                break;
                            case wBComponentTypeNames.businessMemberships:
                                if(allowObject.memberships){
                                    valid = true;
                                }
                                break;
                            case wBComponentTypeNames.businessGiftCertificates:
                                if(allowObject.giftCards){
                                    valid = true;
                                }
                          
                                break;
                            
                            default:
                                break;

                        }
                        if(valid){
                            break;
                        }
                    }

                    if(!valid){
                        hiddenCount++;
                        newStyle +=`${realId} .tab-button-${i} {display:none; !important;}`;
                        if(selected == i){
                            selected++;
                        }
                    }

          

                }
                if(hiddenCount>=tabs.length-1){
                    newStyle +=`${realId} .main-tab-row {display:none !important;}`;
                    newStyle +=`${realId} .tabs-mobile-menu {display:none !important;}`;
                }
                    setStyleState(newStyle);
                if(selected>0)
                    updateToTab(selected);


            }

        }

    },[])

    const updateToTab = (index:number)=>{
        setSelectedTab(index);
        setIsOpen(false);

        if(isEditor){
            setNodeComponentAttributeValue(node,"selectedTab",index.toString());
            let n = node as LayoutNode;
            n.forceUpdate&&n.forceUpdate();
            (window as any).updateTabInput&&(window as any).updateTabInput();
        }

        if(containerRef.current){
            let dom = containerRef.current;
            let classList = dom.classList;
            for(let i = 0;i<classList.length;i++){
                let cl = classList[i];
                if(cl.startsWith(ToggleNames.toggledToIndex)){
                    dom.classList.remove(cl);
                    dom.classList.add(ToggleNames.toggledToIndex+index);
                }
            }

        }
       
    }

let tabName = tabs[selectedTab]??`Tab ${selectedTab+1}`;
if(selectedTab > tabs.length-1){
    tabName = "Not Available"
}
if(tabName.length<1){
    tabName = `Tab ${selectedTab+1}`;
}
    return( 


    <div className="relative w-full no-shrink tabs-mobile-menu " style={{display:"none",zIndex:"10"}} ref={domRef}>
        <style>
            {styleState}
        </style>
        <div className="flex-row justify-between tab-button" style={{padding:"12px",cursor:"pointer"}}
            onClick={ OpenMenu}
        >
            <div>{tabName}</div>
            <DownCaret/>
        </div>
        {isOpen && portalRef.current&&
        createPortal(
         <div className="tab-mobile-options w-full" style={{maxHeight:"300px",overflow:"auto",margin:"0",position:"absolute",top:heightRef.current+"px"}} ref={optionsRef} >
            {tabs.map((tab,index)=>{
                
                if(tab.length<1){
                    tab = `Tab ${index+1}`;
                }

               return (
                <button role="tab" className={"invisible-button tab-button w-full block-edit tab-button-"+index } style={{padding:"12px"}}
                        key={index} onClick={()=>{updateToTab(index)}}>{tab}</button>
                )})
            }
        </div>
        ,portalRef.current    
     )   
        }

    </div>
    )
    



}